var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96323 2H10.0364C10.5216 2 10.9141 2.48523 10.9141 2.87775V5.74421C10.9141 6.22945 10.521 6.62196 10.0364 6.62196H9.96323C9.47799 6.62196 9.08548 6.13672 9.08548 5.74421V2.87775C9.08548 2.39251 9.47864 2 9.96323 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96323 13.378H10.0364C10.5216 13.378 10.9141 13.8633 10.9141 14.2558V17.1223C10.9141 17.6075 10.521 18 10.0364 18H9.96323C9.47799 18 9.08548 17.5148 9.08548 17.1223V14.2558C9.08548 13.7706 9.47864 13.378 9.96323 13.378Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99951 10.0369V9.96372C1.99951 9.47848 2.48475 9.08597 2.87726 9.08597H5.74372C6.22896 9.08597 6.62147 9.47913 6.62147 9.96372V10.0369C6.62147 10.5221 6.13624 10.9146 5.74372 10.9146H2.87726C2.39202 10.9146 1.99951 10.5214 1.99951 10.0369Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3776 10.0369V9.96372C13.3776 9.47848 13.8628 9.08597 14.2553 9.08597H17.1218C17.607 9.08597 17.9995 9.47913 17.9995 9.96372V10.0369C17.9995 10.5221 17.5143 10.9146 17.1218 10.9146H14.2553C13.7701 10.9146 13.3776 10.5214 13.3776 10.0369Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31666 4.36929L4.36825 4.31769C4.71112 3.97482 5.3322 4.03947 5.60977 4.31769L7.63628 6.3442C7.97915 6.68707 7.97915 7.24285 7.63628 7.58572L7.58468 7.63731C7.24181 7.98018 6.62073 7.91553 6.34316 7.63731L4.31666 5.6108C3.97379 5.26793 3.97379 4.71216 4.31666 4.36929Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3627 12.4147L12.4143 12.3631C12.7572 12.0202 13.3782 12.0849 13.6558 12.3631L15.6823 14.3896C16.0252 14.7325 16.0252 15.2882 15.6823 15.6311L15.6307 15.6827C15.2878 16.0256 14.6668 15.9609 14.3892 15.6827L12.3627 13.6562C12.0198 13.3133 12.0198 12.7575 12.3627 12.4147Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36885 15.6834L4.31726 15.6318C3.97438 15.2889 4.03904 14.6679 4.31726 14.3903L6.34376 12.3638C6.68664 12.0209 7.24241 12.0209 7.58528 12.3638L7.63687 12.4154C7.97975 12.7582 7.91509 13.3793 7.63687 13.6569L5.61037 15.6834C5.2675 16.0263 4.71172 16.0263 4.36885 15.6834Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4142 7.63742L12.3626 7.58582C12.0198 7.24295 12.0844 6.62187 12.3626 6.34431L14.3891 4.3178C14.732 3.97493 15.2878 3.97493 15.6307 4.3178L15.6823 4.36939C16.0251 4.71227 15.9605 5.33334 15.6823 5.61091L13.6557 7.63742C13.3129 7.98029 12.7571 7.98029 12.4142 7.63742Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/running.436ea36ad70405876653703acbf373ab.svg";
export { ForwardRef as ReactComponent };